import * as React from 'react';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import i18n from 'i18next';

import { publishCalendarLink2, test2 } from '../../../api/calendar-api';
import { sendCalendarLink } from '../../../../services/smtp';
import Spinner from '../../../../components/spinner/spinner';

// Access Control List
export class Acl2 extends React.Component {
  constructor(props) {
    super(props);
    this.listviewInstance = null;
    this.position = { X: 'Right', Y: 'Top' };
    this.temp = 'roleData';
    this.fields = { text: 'Role', value: 'Id' };
    this.value = 'reader';
    this.listviewInstance = null;
    this.dataACLSource = this.props.aclData;
    this.fieldsList = { text: 'text', iconCss: 'icon' };
    this.onAddPermission = this.onAddPermission.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);

    this.state = {
      calendarid: this.props.calendarId,
      publicUrl: null,
      showSpinner: true
    };

    this.toasts = [
      {
        content: i18n.t('schedule.toast-processing'),
        cssClass: 'e-toast-black',
        icon: ''
      },
      {
        content: i18n.t('schedule.toast-process-complete'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      },
      {
        content: i18n.t('schedule.toast-process-error'),
        cssClass: 'e-toast-danger',
        icon: 'lf-icon lf-icon-close-round'
      },
      {
        content: i18n.t('schedule.toast-processing-email'),
        cssClass: 'e-toast-black',
        icon: ''
      },
      {
        content: i18n.t('schedule.toast-process-email-complete'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      },
      {
        content: i18n.t('schedule.toast-process-email-error'),
        cssClass: 'e-toast-danger',
        icon: 'lf-icon lf-icon-close-round'
      }
    ];

    this.roleData = [
      { Id: 'reader', Role: 'lectura' },
      { Id: 'writer', Role: 'escritura' }
    ];
  }

  toastCusAnimation = {
    hide: { duration: '1' },
    show: { duration: '200' }
  };

  onAddPermission() {
    const id = `user:${this.mailaccountObj.value}`;
    const userId = this.props.userId;
    const calendarData = this.props.calendarData;

    this.toastObj.timeOut = 10000;
    this.toastObj.showProgressBar = true;
    this.toastObj.show(this.toasts[3]);

    sendCalendarLink(
      this.props.lexonToken,
      userId,
      {
        name: calendarData.summary,
        description: calendarData.description,
        downloadLink: this.state.publicUrl
      },
      [{ name: '', text: this.mailaccountObj.value }],
      { name: this.props.userName, email: this.props.userAccount },
      this.props.userSign
    )
      .then(() => {
        this.mailaccountObj.value = '';
        this.toastObj.hide('All');
        this.toastObj.showProgressBar = false;
        this.toastObj.timeOut = 3000;
        this.toastObj.show(this.toasts[4]);
      })
      .catch(() => {
        this.toastObj.hide('All');
        this.toastObj.showProgressBar = false;
        this.toastObj.timeOut = 3000;
        this.toastObj.show(this.toasts[5]);
      });

    const dataPermission = {
      text: this.mailaccountObj.value,
      role: '',
      id: id,
      icon: 'delete-icon'
    };
    this.listviewInstance.addItem([dataPermission]);
    this.props.onChangeShareList(this.listviewInstance);
  }

  deleteItem(args) {
    args.stopPropagation();
    const liItem = args.target.parentElement.parentElement;
    this.listviewInstance.removeItem(liItem);
    this.props.onChangeShareList(this.listviewInstance);
  }

  onDataBinding(items) {
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        const acl = items[i];

        this.dataACLSource.push({
          text: acl.scope.value,
          id: acl.id,
          role: acl.role,
          icon: 'delete-icon'
        });
      }
    }
    this.listviewInstance.refresh();
  }

  listTemplate(data) {
    let owner = false;
    if (data.role == 'owner') {
      owner = true;
    }

    return (
      <div className="text-content">
        {data.text}
        {!owner ? (
          <span
            id="delete-email"
            className="listicons lf-icon-close-round"
            onClick={this.deleteItem.bind(this)}
          />
        ) : (
          ''
        )}
      </div>
    );
  }

  copyToClipboard() {
    const copyText = document.getElementById('link');

    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    navigator.clipboard.writeText(copyText.value);
  }

  componentDidMount() {
    if (
      !this.props.aclData.find(x => x.id === `user:${this.props.userAccount}`)
    ) {
      publishCalendarLink2(
        this.props.calendarId,
        this.props.userId,
        this.props.userAccount,
        this.props.lexonToken
      ).then(() => {
        test2(
          this.props.calendarId,
          this.props.userId,
          this.props.userAccount,
          this.props.lexonToken
        ).then(res => {
          const publishUrl = `${res.body.multistatus.response[0].propstat[0].prop[0]['publish-url'][0].href[0]}?export`;
          this.setState({ publicUrl: publishUrl, showSpinner: false });
        });
      });
    } else {
      test2(this.props.calendarId, this.props.userId, this.props.userAccount, this.props.lexonToken).then(
        res => {
          const publishUrl = `${res.body.multistatus.response[0].propstat[0].prop[0]['publish-url'][0].href[0]}?export`;
          this.setState({ publicUrl: publishUrl, showSpinner: false });
        }
      );
    }
  }

  render() {
    const publicUrl = this.state.publicUrl;
    return (
      <div className="">
        {publicUrl ? (
          <div className="d-flex align-items-center mb-4">
            <div className="acl-public-link-field">
              <div className="form-group">
                <div className="e-float-input">
                  <TextBoxComponent
                    id="link"
                    readOnly={true}
                    value={publicUrl}
                    ref={scope => {
                      this.mailaccountObj = scope;
                    }}
                    className="field-input"
                  />
                </div>
              </div>
            </div>
            <div className="">
              <div className="">
                <div className="">
                  {publicUrl ? (
                    <ButtonComponent
                      cssClass="e-flat e-primary"
                      floatLabelType="Always"
                      onClick={this.copyToClipboard}
                    >
                      COPIAR ENLACE
                    </ButtonComponent>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <Spinner visible={this.state.showSpinner} />
        {publicUrl ? (
          <div className="d-flex align-items-center">
            <div className="acl-public-link-field">
              <div className="form-group">
                <div className="e-float-input">
                  <TextBoxComponent
                    id="mail"
                    placeholder={i18n.t('calendar.email_example')}
                    ref={scope => {
                      this.mailaccountObj = scope;
                    }}
                    className="field-input"
                  />
                </div>
                <div id="noError" />
              </div>
            </div>
            <div className="">
              <div className="">
                <ButtonComponent
                  cssClass="e-flat e-primary"
                  floatLabelType="Always"
                  onClick={this.onAddPermission}
                >
                  Enviar
                </ButtonComponent>
              </div>
            </div>
          </div>
        ) : null}

        <ToastComponent
          ref={toast => {
            this.toastObj = toast;
          }}
          id="toast_pos"
          position={this.position}
          target={this.target}
          animation={this.toastCusAnimation}
          timeOut={7000}
          showCloseButton
          open={true}
        ></ToastComponent>
      </div>
    );
  }
}

export default Acl2;
